export const environment = {
  production: true,
  isETopocartDev: false,
  isETopocartProd: true,
  isTopocart: false,
  isTopocartDev: false,
  isPortoVelho: false,
  isAlexania: false,
  isManaus: false,

  googleMapsKey: 'AIzaSyDa_RGUAd9-34P9bgA4181u_TPurVM-5FE',
  googleMapsAPI: 'https://maps.googleapis.com/maps/api/',
  /* Para ambientes onPremise é necessário a modificação da chave
  do reCAPTCHA, acesse https://www.google.com/recaptcha/admin
  com uma conta do dominio @topocart.com.br e crie uma chave para o dominio
do tipo v2/checkbox  que sera realizado o deploy */
  captchaKey: '6LcvkeAUAAAAAHy5Kofj78q5mntZFwHwL98KBFGI',
  googleGeoCodeAPI: 'https://maps.googleapis.com/maps/api/geocode/json',
  reportsUrl: 'https://relatorios.geo360.com.br/',
  reportUrl: 'https://relatorios.geo360.com.br/',

  visualizador360BaseUrl: 'https://visualizador360.geo360.com.br',
  apiUrl: 'https://plataforma.geo360.com.br/',
  conversorUrl: 'https://conversor.geo360.com.br/',
  apiDjangoUrl: 'https://plataforma.geo360.com.br/django/',
  apiUrlPostgrest: `https://rest-<placeholder>.geo360.com.br`,
  apiUrlGenericPostgrest: `https://rest-plataforma.geo360.com.br`,
  apiUrlGenericPGTiles: `https://api-gateway.geo360.com.br/plataforma/tiles/`,
  apiUrlPGTiles: `https://tiles-<placeholder>.geo360.com.br/`,
  apiDjangoDirectUrl: 'https://cadastro.geo360.com.br/',
  djangoDirectUrlToken: 'Bearer 54d1a258-cce2-4e77-afbc-5bd350c55465',
  apiAttributesTable: 'https://tabela-atributos.geo360.com.br/',
  postgRestUrl: 'https://rest-<placeholder>.geo360.com.br',
  pgtilesUrl: 'https://tiles-<placeholder>.geo360.com.br',
  caracterizacaoUrl: 'https://caracterizacao.geo360.com.br',
  reportV2Url: 'https://relatorios-v2.geo360.com.br/',

  openRestUrl: 'https://openrest.geo360.com.br/',

  apiCNAE:
    'https://cnae.criciuma.apps.etopocart.com/',

  // apiUrl: 'https://api4.appsgeo.io/' /* API Oficial */,
  geoServerUrl: 'https://mapsrv2.appsgeo.io/geoserver/',
  // apiUrl: 'https://staging-api.appsgeo.io/' /* API Staging */,
  geoServerWFSUrl:
    'https://mapsrv2.appsgeo.io/geoserver/wfs' /* GeoServer WFS */,
  photonApi: 'https://photon.komoot.de/api/' /* Photon API */,
  firebase: {
    apiKey: 'AIzaSyD4riPTBVU39qjL336AjXfdroCJwNUwQvg',
    authDomain: 'appsgeo-test.firebaseapp.com',
    databaseURL: 'https://appsgeo-test.firebaseio.com',
    projectId: 'appsgeo-test',
    storageBucket: 'appsgeo-test.appspot.com',
    messagingSenderId: '358703366933',
    appId: '1:358703366933:apps:27b8be17ee90f30ba35f1c',
  },
  recaptchaKey: '6LcvkeAUAAAAAHy5Kofj78q5mntZFwHwL98KBFGI',
  mapboxToken:
    'pk.eyJ1Ijoidm0ybWFwYm94IiwiYSI6ImNrbTF6MTYzczB6aGYybnIzcDY0eW9vb2sifQ.J9ErWF5EO5w3oLqGjzqi_w',
  apiGatewayUrl: 'https://api-gateway.geo360.com.br/',
};
